import React from 'react';

import { withCartContext } from '@raise/with-cart-context-provider';
import UnifiedCartMenu from '../../../../../shared-components/unified-cart-menu/src';
import LegacyCartMenu from '../../../../../shared-components/cart-menu/src';

import { cartIcon } from './images';

const unified = (props) => {
  return (
    <UnifiedCartMenu {...props}>
      {cartIcon}
    </UnifiedCartMenu>
  );
};
const UnifiedCartWithContext = withCartContext(unified);
export const UnifiedCartButton = ({ model, uuid, isSlave, extSetState }) => {
  return (
    <UnifiedCartWithContext
      isSlave={isSlave}
      cartContextState={model.cartContextState}
      uuid={uuid}
      isUnifiedCart
      extSetState={extSetState}
    />
  );
};

const legacy = (props) => {
  return (
    <LegacyCartMenu {...props}>
      {cartIcon}
    </LegacyCartMenu>
  );
};
const LegacyAppFrameWithContext = withCartContext(legacy);
export const LegacyCartButton = ({ model, uuid, isSlave, extSetState }) => {
  return (
    <LegacyAppFrameWithContext
      isSlave={isSlave}
      cartContextState={model.cartContextState}
      uuid={uuid}
      isUnifiedCart={false}
      extSetState={extSetState}
    />
  );
};
